export default "__VITE_ASSET__Cki91FW3__"